import { useEffect } from "react";
import { X } from "lucide-react";

function Modal({
  isOpen,
  onClose,
  children,
  panelClassName = "max-w-xl",
  showClose = true,
  closeLabel = "Close modal",
}) {
  useEffect(() => {
    if (!isOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/55 px-4 py-6"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className={`relative w-full rounded-2xl bg-white p-6 shadow-2xl sm:p-7 ${panelClassName}`}
        onClick={(event) => event.stopPropagation()}
      >
        {showClose && onClose ? (
          <button
            type="button"
            className="absolute right-5 top-5 text-slate-500 transition hover:text-slate-700"
            aria-label={closeLabel}
            onClick={onClose}
          >
            <X className="h-5 w-5" />
          </button>
        ) : null}
        {children}
      </div>
    </div>
  );
}

export default Modal;
